import { Box, Container, Grid } from "@mui/joy";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApplicants } from "context/ApplicantsContext";
import MeetCandidatesButton from "../../../../components/common/CandidateList/components/MeetCandidatesButton";
import CandidateList from "components/common/CandidateList";

interface CandidateListProps {
  candidates: any[];
  isEmployerLoggedIn: boolean;
  loading?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => Promise<void>;
  totalCandidates?: number;
  error?: string | null;
}

const DeprecatedCandidateList: React.FC<CandidateListProps> = ({ 
  candidates, 
  isEmployerLoggedIn,
  loading = false,
  hasMore = false,
  onLoadMore,
  totalCandidates = 0,
  error = null
}) => {
  const [activeCardIndex, setActiveCardIndex] = useState<string | null>(null);
  const [playing, setPlaying] = useState(true);
  const [muted, setMuted] = useState(false);
  
  const [searchParams] = useSearchParams();
  const currentZipcode = searchParams.get('zipcode') || '';
  const currentPositions = searchParams.get('positions') || '';

  const handleCardVisibilityChange = (videoId: string, isVisible: boolean) => {
    console.log('handleCardVisibilityChange', videoId, isVisible);
    if (isVisible) {
      setActiveCardIndex(videoId);
    }
  };

  // Handle scroll to bottom for infinite loading
  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || loading || !onLoadMore) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Check if user is near the bottom (within 300px - trigger earlier)
      if (scrollTop + windowHeight >= documentHeight - 300) {
        onLoadMore();
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasMore, loading, onLoadMore]);

  return (
    <Box sx={{ flex: 1, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid xs={12} sx={{ maxWidth: { xs: "600px", md: "none" }, mx: { xs: "auto", md: 0 } }}>
          <CandidateList 
            candidates={candidates} 
            activeVideoId={activeCardIndex || ''}
            muted={muted}
            setMuted={setMuted}
            playing={playing}
            setPlaying={setPlaying}
            onVisibilityChange={(videoId: string, isVisible: boolean) => handleCardVisibilityChange(videoId, isVisible)}
            loading={loading}
            error={error}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
            totalCandidates={totalCandidates}
            enableZipcodeFilter={true}
            enableRolesFilter={true}
            enableEmployerFilter={isEmployerLoggedIn}
            enableEmployerPositionsFilter={false}
            showEmployerToggle={true}
          />
        </Grid>          
      </Container>
    </Box>
  )
}

export default DeprecatedCandidateList;